import { gql } from 'graphql-request';

import {
  GlobalCompanyTabCompanyType,
  GlobalCompanyTabCreatedAt,
  GlobalCompanyTabID,
  GlobalCompanyTabName,
  GlobalCompanyTabNanoID,
  GlobalCompanyTabPosition,
  GlobalCompanyTabRole,
  GlobalCompanyTabType,
  GlobalCompanyTabUpdatedAt,
  GlobalCompanyTabUser,
  GlobalCompanyTabUserID,
  GlobalCompanyTabUUID
} from '../globalCompanyTabsTypes';

import { CreateItemGqlError } from '../../../types';

export interface CreateGlobalCompanyTabQueryResponse {
  createGlobalCompanyTab: {
    status: string;
    recordUuid: GlobalCompanyTabUUID;
    record: {
      id: GlobalCompanyTabID;
      uuid: GlobalCompanyTabUUID;
      nanoId: GlobalCompanyTabNanoID;
      name: GlobalCompanyTabName;
      content: string | null;
      position: GlobalCompanyTabPosition;
      type: GlobalCompanyTabType;
      companyType: GlobalCompanyTabCompanyType;
      createdAt: GlobalCompanyTabCreatedAt;
      updatedAt: GlobalCompanyTabUpdatedAt;
      userId: GlobalCompanyTabUserID;
      user: GlobalCompanyTabUser;
      roles: GlobalCompanyTabRole[];
    };
    errors: {
      name: CreateItemGqlError;
      content: CreateItemGqlError;
      companyType: CreateItemGqlError;
      position: CreateItemGqlError;
      fullMessages: string[];
    };
  };
}

export const CREATE_GLOBAL_COMPANY_TAB_QUERY = gql`
  mutation CreateGlobalCompanyTab(
    $nanoId: NanoId
    $companyType: String!
    $name: String!
    $content: String
    $position: Int
    $roleUids: [Uid!]
  ) {
    createGlobalCompanyTab(
      input: {
        nanoId: $nanoId
        companyType: $companyType
        name: $name
        content: $content
        position: $position
        roleUids: $roleUids
      }
    ) {
      errors {
        fullMessages
        name
        content
        companyType
        position
      }
      record {
        companyType
        content
        createdAt
        id
        name
        nanoId
        position
        type
        updatedAt
        userId
        uuid
        user {
          id
          nanoId
        }
        roles {
          id
          name
          nanoId
          uuid
        }
      }
      recordUuid
      status
    }
  }
`;
